
// Read configuration from environment variables (create-react-app expects REACT_APP_* vars)

// Require REACT_APP_ENV to be set explicitly to choose which environment vars to read
const env = process.env.REACT_APP_ENV;
if (!env) {
    throw new Error('REACT_APP_ENV is not set. Please set REACT_APP_ENV to one of: local, development, production');
}

const readEnv = (name, envKey) => {
    // Check for a specific override first, e.g. REACT_APP_API_DEVELOPMENT
    const specific = process.env[`REACT_APP_${name.toUpperCase()}_${envKey.toUpperCase()}`];
    if (specific) return specific;

    // Then check generic envs like REACT_APP_API_URL or REACT_APP_API
    const generic = process.env[`REACT_APP_${name.toUpperCase()}_URL`] || process.env[`REACT_APP_${name.toUpperCase()}`];
    if (generic) return generic;

    // No default fallback — throw to make misconfiguration obvious at build time
    throw new Error(`Missing environment variable for ${name} (${envKey}). Checked REACT_APP_${name.toUpperCase()}_${envKey.toUpperCase()}, REACT_APP_${name.toUpperCase()}_URL, REACT_APP_${name.toUpperCase()}`);
};

// Public helpers — these will throw if the expected env vars are not set
export const getApiBaseUrl = () => readEnv('api', env);
// console.log("API BASE URL: ", getApiBaseUrl());

export const getClientBaseUrl = () => readEnv('client', env);
export const getRootUrl = () => readEnv('root', env);

// Backwards compatibility: export functions instead of precomputed maps
const config = { getApiBaseUrl, getClientBaseUrl, getRootUrl };
export default config;
